import AlertMessage from "@/components/library/Alerts/AlertMessage";
import Input from "@/components/library/Inputs/Input";
import {
  type IFormInputsViewModel,
  LoginSection,
} from "@/components/screens/login/types/login";
import { InputType } from "@/types/library/Inputs";

const LoginFormInputs = ({ vm }: { vm: IFormInputsViewModel }) => (
  <>
    {vm.query.error && (
      <div className="mb-4">
        <AlertMessage
          title="Could not log you in"
          className="rounded-lg border-none"
          id="login-error-message"
        />
      </div>
    )}

    <span className="font-bold text-lg text-white">{vm.labels.title}</span>
    <div className="mt-2 mb-4">
      <Input
        id="username"
        inputType={InputType.Text}
        placeholder="Username"
        customRef={vm.usernameRef}
        value={vm.usernameRef?.current?.value}
        onChange={() => {}}
      />
    </div>
    {vm.forgotPasswordError.hasForgotPasswordError && (
      <div className="mb-4">
        <AlertMessage
          title={vm.forgotPasswordError.error}
          className="rounded-lg border-none"
          id="forgotten-password-error-message"
        />
      </div>
    )}
    {vm.currentSection === LoginSection.Login && (
      <>
        <div className="mb-2">
          <Input
            id="password"
            inputType={InputType.Password}
            placeholder="Password"
            customRef={vm.passwordRef}
            value={vm.passwordRef?.current?.value}
            onChange={() => {}}
          />
        </div>

        <div
          className="text-white hover:cursor-pointer hover:underline"
          id="forgot-password"
          data-testid="forgot-password"
          role="button"
          tabIndex={0}
          onClick={() => {
            vm.setCurrentSection(LoginSection.ForgotPassword);
          }}
          onKeyDown={() => {
            vm.setCurrentSection(LoginSection.ForgotPassword);
          }}
        >
          Forgot Password?
        </div>
      </>
    )}
  </>
);

export default LoginFormInputs;
